import React, { useCallback, useEffect, useState } from 'react';
import api, { getApiErrorMessage } from '../api';
import './presentations/Presentations.css';

const PAGE = 50;
const fmt = (v) => (v ? new Date(v).toLocaleString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
const STATUS = { pending: 'ждёт файл', sent: 'отправлено', failed: 'ошибка отправки' };

/** Админка: кто оставил почту ради презентации, где, когда и на что согласился. */
function AdminPresentationConsents() {
    const [q, setQ] = useState('');
    const [query, setQuery] = useState('');
    const [offset, setOffset] = useState(0);
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    const load = useCallback(async () => {
        try {
            const res = await api.get('/admin/presentations/consents', { params: { q: query || undefined, limit: PAGE, offset } });
            setData(res.data);
            setError('');
        } catch (err) {
            setError(getApiErrorMessage(err, 'Не удалось загрузить'));
        }
    }, [query, offset]);

    useEffect(() => { load(); }, [load]);

    const exportCsv = async () => {
        try {
            const res = await api.get('/admin/presentations/consents/export', { params: { q: query || undefined }, responseType: 'blob' });
            const url = URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'participant-consents.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (err) {
            setError(getApiErrorMessage(err, 'Не удалось выгрузить'));
        }
    };

    return (
        <div className="aconsent">
            <p className="pres-muted">
                Участники, оставившие почту, чтобы получить презентацию. Для каждого — когда и на что он согласился, с какого IP-адреса.
                Запросы хранятся {data?.keep_days || 90} дней; согласия на рассылку — пока участник не отпишется.
            </p>
            {data && (
                <details className="aconsent-texts">
                    <summary>Тексты согласий (версия от {data.version})</summary>
                    <ul>
                        <li><b>Обработка почты</b> (обязательно): «{data.texts.pd}»</li>
                        <li><b>Рассылка СВОД</b> (по желанию): «{data.texts.marketing}»</li>
                        <li><b>Передать организатору</b> (по желанию): «{data.texts.share}»</li>
                    </ul>
                </details>
            )}
            <form className="aconsent-search" onSubmit={(e) => { e.preventDefault(); setOffset(0); setQuery(q.trim()); }}>
                <input type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Поиск по почте" aria-label="Поиск по почте" />
                <button type="submit" className="btn btn--secondary btn--sm">Найти</button>
                <button type="button" className="btn btn--secondary btn--sm" onClick={exportCsv} disabled={!data?.total}>Скачать CSV</button>
            </form>
            {error && <p className="pres-error" role="alert">{error}</p>}
            {data && data.items.length === 0 && <p className="pres-empty">{query ? 'Ничего не найдено.' : 'Пока никто не оставлял почту.'}</p>}
            {data && data.items.length > 0 && (
                <>
                    <div className="pres-table-wrap">
                        <table className="pres-table aconsent-table">
                            <thead>
                                <tr>
                                    <th>Почта</th>
                                    <th>Где</th>
                                    <th>Обработка почты</th>
                                    <th>Рассылка СВОД</th>
                                    <th>Передать организатору</th>
                                    <th>Письмо</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.items.map((r) => (
                                    <tr key={r.id}>
                                        <td><b>{r.email}</b></td>
                                        <td>{r.source}<small>организатор: {r.organizer || '—'}</small></td>
                                        <td>{fmt(r.consent_at)}<small>IP {r.consent_ip || '—'}{r.consent_version ? ` · текст от ${r.consent_version}` : ''}</small></td>
                                        <td>
                                            {!r.newsletter && <span className="aconsent-no">нет</span>}
                                            {r.newsletter?.state === 'agreed' && <span className="aconsent-yes">да</span>}
                                            {r.newsletter?.state === 'revoked' && <span className="aconsent-revoked">отозвано</span>}
                                            {r.newsletter && <small>{fmt(r.newsletter.at)}{r.newsletter.how ? ` · ${r.newsletter.how}` : ''}</small>}
                                        </td>
                                        <td>{r.shared_at ? <><span className="aconsent-yes">да</span><small>{fmt(r.shared_at)}</small></> : <span className="aconsent-no">нет</span>}</td>
                                        <td>{STATUS[r.status] || r.status}<small>{r.downloaded_at ? `скачал ${fmt(r.downloaded_at)}` : r.sent_at ? fmt(r.sent_at) : ''}</small></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="aconsent-pages">
                        <span className="pres-muted">{offset + 1}–{offset + data.items.length} из {data.total}</span>
                        <button type="button" className="btn btn--secondary btn--sm" disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - PAGE))}>← Назад</button>
                        <button type="button" className="btn btn--secondary btn--sm" disabled={offset + PAGE >= data.total} onClick={() => setOffset(offset + PAGE)}>Дальше →</button>
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminPresentationConsents;
